import styled from 'styled-components';
import { pl } from '@lendi-ui/spacing';
import { Heading } from '@lendi-ui/typography';

export const Title = styled.div`
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LoanHeading = styled(Heading)`
  ${pl('sm')}
`;
